const META_API_VERSION = 'v25.0'

const parseEnvArrNumber = (value: string | undefined): number[] | undefined => {
  if (!value) {
    return undefined
  }

  const trimmedValue = value.trim()

  if (!trimmedValue) {
    return undefined
  }

  return trimmedValue.split(',').map((orgId) => Number.parseInt(orgId.trim(), 10))
}

const DEBOUNCE_TIME: { [char: string]: number } = {
  test: 20,
  mock: 100, // for integration test
  development: 500,
  staging: 500,
  production: 500,
  preview: 500,
}

const POLL_TIME: { [char: string]: number } = {
  test: 20,
  mock: 100,
  development: 5000,
  staging: 5000,
  production: 5000,
  preview: 5000,
}

export default {
  version: import.meta.env.VITE_VERSION,
  env: {
    app: import.meta.env.VITE_APP_ENV,
  },
  ws: {
    url: import.meta.env.VITE_WSS_URL,
  },
  webRTC: {
    url: import.meta.env.VITE_WEBRTC_URL,
    username: import.meta.env.VITE_WEBRTC_USERNAME,
    password: import.meta.env.VITE_WEBRTC_PASSWORD,
  },
  svc: {
    url: import.meta.env.VITE_API_SVC_URL,
  },
  stripe: {
    key: import.meta.env.VITE_STRIPE_KEY,
  },
  recaptcha: {
    key: import.meta.env.VITE_RECAPTCHA_KEY,
  },
  vendor: {
    css: [
      {
        name: 'font-main',
        type: 'font',
        family: '"Source Sans Pro", "Helvetica", "Arial", sans-serif',
        style: 'normal',
        url: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro',
      },
      {
        name: 'material-icons',
        url: 'https://fonts.googleapis.com/icon?family=Material+Icons',
      },
    ],
    js: [
      {
        name: 'stripe',
        url: 'https://js.stripe.com/v3/',
      },
    ],
  },
  modules: {
    contacts: {
      pageSize: {
        default: 100,
        values: [25, 50, 100],
      },
    },
    cati: {
      pageSize: {
        default: 100,
        values: [25, 50, 100],
      },
    },
    exports: {
      pageSize: {
        default: 25,
      },
    },
    messages: {
      pageSize: {
        default: 100,
        values: [25, 50, 100],
      },
    },
    conversations: {
      pageSize: {
        default: 100,
      },
    },
    campaigns: {
      pageSize: {
        default: 100,
        values: [25, 50, 100],
      },
    },
    groups: {
      type: {
        type: 'NORMAL',
        name: 'groups',
        label: 'Groups',
        icon: 'format_list_bulleted',
      },
      pageSize: {
        default: 30,
      },
    },
    segments: {
      type: {
        type: 'SMART',
        name: 'segments',
        label: 'Segments',
        icon: 'transform',
      },
      pageSize: {
        default: 30,
      },
    },
    notifications: {
      pollInterval: 1000,
    },
  },
  display: {
    format: {
      date: 'YYYY MMM DD',
      dateTime: 'YYYY MMM DD HH:mm:ss',
      orgReportFilter: 'YYYY-MM-DD HH:mm',
    },
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  clearFeed: {
    clientId: import.meta.env.VITE_CLEARFEED_CLIENT_ID,
  },
  meta: {
    appId: import.meta.env.VITE_META_APP_ID,
    apiVersion: META_API_VERSION,
    configureId: import.meta.env.VITE_META_CONFIGURE_ID,
    solutionId: import.meta.env.VITE_TWILIO_META_SOLUTION_ID,
    orgWhitelist: parseEnvArrNumber(import.meta.env.VITE_META_ORG_WHITELIST),
  },
  debounce: {
    time: DEBOUNCE_TIME[import.meta.env.MODE],
  },
  poll: {
    time: POLL_TIME[import.meta.env.MODE],
  },
}
